/**
 * Group/Workspace API — typed wrappers around legacy groupApi.js.
 */
import { getRootWorkspaceDetails as legacyGetRootWorkspaceDetails } from '../apiServices/groupApi';

export interface WorkspaceUsage {
  usedBytes: { N: string };
  sentBytes: {
    thisMonth: { N: string };
    lastMonth: { N: string };
  };
}

export async function getRootWorkspaceDetails(): Promise<WorkspaceUsage> {
  const response = await legacyGetRootWorkspaceDetails();
  return (response as { response: WorkspaceUsage }).response;
}
